export function initials(abbreviation?: string | null, name?: string | null, email?: string | null): string {
  if (abbreviation && abbreviation.trim().length >= 2) return abbreviation.trim().toUpperCase();
  const src = (name ?? email ?? '?').trim();
  const parts = src.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
}
